export enum AIBackground {
    TRANSPARENT = "TRANSPARENT",
    OFFICE_1 = "OFFICE_1",
    OFFICE_2 = "OFFICE_2",
    OFFICE_3 = "OFFICE_3",
    OFFICE_4 = "OFFICE_4",
    OFFICE_5 = "OFFICE_5",
    OFFICE_6 = "OFFICE_6",
    OFFICE_7 = "OFFICE_7",
    OFFICE_8 = "OFFICE_8",
    OFFICE_9 = "OFFICE_9",
    OFFICE_10 = "OFFICE_10",
    OFFICE_11 = "OFFICE_11",
    OFFICE_12 = "OFFICE_12"
}
